import type {
  AssetsDrawingPrimitiveSchema,
  AssetsDrawingSchema,
} from '@iconik-io/iconik-api/src/services/assets';
import type { Annotation } from '@iconik-io/unified-player-core';

import { DRAWING_VERSION_NORMALIZED } from './annotation_versions';

export function serializeUnifiedAnnotation(
  annotation: Annotation,
): AssetsDrawingSchema | undefined {
  if (Object.keys(annotation).length === 0) {
    return undefined;
  }
  const result: AssetsDrawingPrimitiveSchema[] = [];
  for (const [, value] of Object.entries(annotation)) {
    if (value.type === 'LASER') {
      continue;
    }
    const primitiveData = {
      type: value.type,
      points: value.points.map((point) => ({
        x: point.x,
        y: point.y,
      })),
      color: value.options.color,
      width: value.options.width,
      opacity: value.options.opacity,
      text: value.type === 'TEXT' ? value.options.text : undefined,
    };

    result.push(primitiveData);
  }

  if (result.length === 0) {
    return undefined;
  }

  return {
    version: DRAWING_VERSION_NORMALIZED,
    primitives: result,
  };
}
